import { StructuredAnalysisHttpClient } from '../../services/httpClient';

const setRichText = ({
  projectId,
  libraryItemId,
  name,
  richTextData,
  childItemIds,
}) => {
  const path = `projects/${projectId}/LibraryItems/richText/${libraryItemId}`;
  const body = {
    name,
    richTextData,
    childItemIds,
  };

  return StructuredAnalysisHttpClient.put(path, body);
};

export default setRichText;
